<div class="position-relative">
  <div *ngIf="isShow" class="popover-box">
    <ng-content></ng-content>
  </div>
</div>
